import * as React from 'react';

const MyCarouselSlide = ({ children, active }) => (
  <div className={`carousel-item ${active}`}>
    {children}
  </div>
);

export default MyCarouselSlide;
